import { TooltipOptions } from '@cloudfactorydk/ng2-tooltip-directive';

export const DefaultTooltipOptions: TooltipOptions = {
  'displayTouchscreen': true,
  'hideDelayTouchscreen': 300,
  'show-delay': 100,
  'hideDelayAfterClick': 500
};
